import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Mail, Instagram, ArrowRight } from "lucide-react";
import Navbar from "@/components/landing/Navbar";
import Footer from "@/components/landing/Footer";

export default function ContactUs() {
  useEffect(() => {
    document.title = "Contact Us — Biker Boulevard";
    window.scrollTo(0, 0);
  }, []);

  return (
    <main data-testid="contact-page" className="relative bg-[#0D0F12] text-white min-h-screen overflow-x-hidden">
      <div className="fixed inset-0 pointer-events-none -z-10">
        <div className="absolute inset-0" style={{ background: "radial-gradient(ellipse at 50% 0%, rgba(0,204,204,0.06), transparent 50%), #0D0F12" }} />
      </div>
      <Navbar />
      <div className="pt-28 pb-24 max-w-3xl mx-auto px-5 md:px-8">
        <span className="text-[10px] font-mono tracking-[0.3em] uppercase text-[#00cccc]">// Contact</span>
        <h1 className="mt-2 text-3xl sm:text-4xl font-black tracking-tight" data-testid="contact-title">Contact Us</h1>
        <p className="mt-3 text-lg sm:text-xl font-semibold text-gradient-cyan" data-testid="contact-tagline">We&apos;re here for the ride.</p>

        <p className="mt-6 text-sm sm:text-[15px] text-zinc-400 leading-relaxed">
          Have a question, want to list your motorcycle, or looking to collaborate with Biker Boulevard? We&apos;d love to hear from you.
        </p>

        <div className="mt-10 p-6 rounded-2xl glass space-y-5" data-testid="contact-card">
          <a
            href="mailto:reachbikerblvd@gmail.com"
            data-testid="contact-email-link"
            className="flex items-center gap-4 group"
          >
            <span className="w-11 h-11 rounded-full border border-[#00cccc]/30 bg-[#00cccc]/10 flex items-center justify-center text-[#00cccc] group-hover:shadow-[0_0_18px_rgba(0,204,204,0.5)] transition-all">
              <Mail className="w-5 h-5" />
            </span>
            <span>
              <span className="block text-[10px] font-mono uppercase tracking-[0.25em] text-zinc-500">Email</span>
              <span className="block text-white font-semibold group-hover:text-[#00cccc] transition-colors">reachbikerblvd@gmail.com</span>
            </span>
          </a>
          <div className="h-px bg-white/10" />
          <a
            href="https://www.instagram.com/bikerboulevard"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="contact-instagram-link"
            className="flex items-center gap-4 group"
          >
            <span className="w-11 h-11 rounded-full border border-[#00cccc]/30 bg-[#00cccc]/10 flex items-center justify-center text-[#00cccc] group-hover:shadow-[0_0_18px_rgba(0,204,204,0.5)] transition-all">
              <Instagram className="w-5 h-5" />
            </span>
            <span>
              <span className="block text-[10px] font-mono uppercase tracking-[0.25em] text-zinc-500">Instagram</span>
              <span className="block text-white font-semibold group-hover:text-[#00cccc] transition-colors">@bikerboulevard</span>
            </span>
          </a>
        </div>

        <p className="mt-10 text-sm sm:text-[15px] text-zinc-400 leading-relaxed">
          Whether you&apos;re buying, selling, or simply passionate about motorcycles, get in touch. Let&apos;s ride forward together.
        </p>
        <p className="mt-4 font-[Unbounded] text-base font-bold tracking-tight">
          <span className="text-white">BIKER </span><span className="text-[#00cccc]">BOULEVARD</span>
        </p>

        <div className="mt-10 flex flex-wrap gap-3">
          <Link
            to="/list-my-bike"
            data-testid="contact-cta-list"
            className="px-6 py-3 rounded-full bg-[#00cccc] text-black text-sm font-semibold hover:shadow-[0_0_24px_rgba(0,204,204,0.6)] transition-all flex items-center gap-2"
          >
            List My Bike <ArrowRight className="w-4 h-4" />
          </Link>
          <Link
            to="/marketplace"
            data-testid="contact-cta-marketplace"
            className="px-6 py-3 rounded-full border border-white/15 text-sm font-semibold text-zinc-200 hover:border-[#00cccc]/50 hover:text-[#00cccc] transition-all flex items-center gap-2"
          >
            Explore Marketplace <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
      <Footer />
    </main>
  );
}
